import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import * as React from 'react'
import {Suspense} from 'react'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'

import {useBuildStatusTooltip} from '../../../../../hooks/useBuildStatusTooltip'
import type {BuildTypeId, BuildId} from '../../../../../types'

import type {BuildPersonalChangeCommentQuery} from './BuildPersonalChangeComment/__generated__/BuildPersonalChangeCommentQuery.graphql'
import BuildPersonalChangeComment from './BuildPersonalChangeComment/BuildPersonalChangeComment'

type Props = {
  personalChangeCommentQueryRef?: PreloadedQuery<BuildPersonalChangeCommentQuery> | null
  buildId: BuildId
  buildTypeId?: BuildTypeId | null | undefined
}

function BuildStatusTooltip({buildId, buildTypeId, personalChangeCommentQueryRef}: Props) {
  const children = useBuildStatusTooltip(buildId)

  return (
    <React.Fragment>
      {children}
      {personalChangeCommentQueryRef != null && (
        <React.Fragment>
          <br />
          {'Personal change: '}
          <Suspense fallback={<LoaderInline />}>
            <BuildPersonalChangeComment
              queryRef={personalChangeCommentQueryRef}
              buildTypeId={buildTypeId}
            />
          </Suspense>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default BuildStatusTooltip
